import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);
export function  isMobile (value){
    // console.log(value)
    let phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    if(!value){
        Toast('请输入手机号');
        return false;
    }else if(!phone.test(value)){
        Toast('请输入手机号有误');
        return false;
    }
    return true
}
export function  isCard (value){
    // console.log(value)
    let card = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
    if(!value){
        Toast('请输入身份证');
        return false;
    }else if(!card.test(value)){
        Toast('请输入身份证有误');
        return false;
    }
    return true
}